import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import de from './locales/de/common.json';
import en from './locales/en/common.json';
import uk from './locales/uk/common.json';
import tr from './locales/tr/common.json';
import pl from './locales/pl/common.json';
import ro from './locales/ro/common.json';
import ru from './locales/ru/common.json';

/**
 * Unterstützte Sprachen. `country` ist der ISO-3166-Ländercode für die
 * Flagge im Sprachselektor (Sprache ≠ Land, aber Flaggen sind die gewünschte
 * UX): en→GB, uk→UA usw.
 */
export const SUPPORTED_LANGUAGES = [
  { code: 'de', country: 'DE' },
  { code: 'en', country: 'GB' },
  { code: 'uk', country: 'UA' },
  { code: 'tr', country: 'TR' },
  { code: 'pl', country: 'PL' },
  { code: 'ro', country: 'RO' },
  { code: 'ru', country: 'RU' },
] as const;

export type LanguageCode = (typeof SUPPORTED_LANGUAGES)[number]['code'];

/** localStorage-Key – konsistent mit dem App-Schema (immokompass:*). */
export const LANGUAGE_STORAGE_KEY = 'immokompass:lang';

const resources = {
  de: { common: de },
  en: { common: en },
  uk: { common: uk },
  tr: { common: tr },
  pl: { common: pl },
  ro: { common: ro },
  ru: { common: ru },
} as const;

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'de',
    supportedLngs: SUPPORTED_LANGUAGES.map((l) => l.code),
    // en-US → en, ru-RU → ru …
    nonExplicitSupportedLngs: true,
    load: 'languageOnly',
    defaultNS: 'common',
    ns: ['common'],
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: LANGUAGE_STORAGE_KEY,
      caches: ['localStorage'],
    },
    interpolation: { escapeValue: false },
    returnNull: false,
  });

export default i18n;
